import script from "./CareerYouthProgramsPupilsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerYouthProgramsPupilsPage.vue?vue&type=script&setup=true&lang=js"

import "./CareerYouthProgramsPupilsPage.vue?vue&type=style&index=0&id=81bed210&lang=scss"

const __exports__ = script;

export default __exports__